$(function () {
  $(document).on(
    "click",
    ".catalog-registration-config-page details.accordion__item:not([open]) > .accordion__header",
    ensureOnlyOneOpenSection
  );
});

function ensureOnlyOneOpenSection(e) {
  /*
      We are opening one of the section, we want to close the other one if it is opened.
      The goal of this is that our user understands that only one of the configuration will be saved.
    */
  const bothSections = $(".catalog-registration-config-page details.accordion__item");

  bothSections.each(function (index, section) {
    if (section !== e.target.parentElement) {
      section.open = false;
    }
  });
}
